module.exports = "pegasus/assets/graycircle-facebook.gif";